import React from "react";
import { Link } from "react-router-dom";
import { Flame } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-blue-900/30 bg-[#0A1026]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
      <div className="col-span-2 md:col-span-1">
        <div className="flex items-center gap-2 mb-3">
          <span className="w-8 h-8 rounded-lg flex items-center justify-center tb-btn-primary">
            <span className="font-head font-extrabold text-white text-sm">T</span>
          </span>
          <span className="font-head font-extrabold text-white">
            Travis<span className="tb-gradient-text">B</span>
          </span>
        </div>
        <p className="text-sm text-gray-400 leading-relaxed">
          Nigeria's fastest crypto & giftcard exchange. Trade in minutes, get paid instantly.
        </p>
      </div>
      <div>
        <h4 className="font-head font-semibold text-white mb-3 text-sm">Product</h4>
        <ul className="space-y-2 text-sm text-gray-400">
          <li><Link to="/rates" className="hover:text-blue-300">Live Rates</Link></li>
          <li><Link to="/signup" className="hover:text-blue-300">Create Account</Link></li>
          <li><Link to="/login" className="hover:text-blue-300">Login</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-head font-semibold text-white mb-3 text-sm">Trade</h4>
        <ul className="space-y-2 text-sm text-gray-400">
          <li>Bitcoin / USDT</li>
          <li>Gift Cards</li>
          <li>Instant Payout</li>
        </ul>
      </div>
      <div>
        <h4 className="font-head font-semibold text-white mb-3 text-sm">Company</h4>
        <ul className="space-y-2 text-sm text-gray-400">
          <li>gettravisb.com</li>
          <li>Support 24/7</li>
          <li>Lagos, Nigeria</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-blue-900/30 py-5 text-center text-xs text-gray-500">
      © {new Date().getFullYear()} TravisB Exchange. All rights reserved.
    </div>
  </footer>
);
